import { type ChartOptions } from 'chart.js';
import { type ZoomPluginOptions } from 'chartjs-plugin-zoom/types/options';

import { type BarOrLineChart } from './chart-bar-line.component';

export const defaultOptionsBarLineChart = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: 'index',
    axis: 'xy',
    intersect: false,
  },
  animation: {
    easing: 'easeOutCubic',
    duration: 300,
  },
  transitions: {
    zoom: {
      animation: {
        duration: 100,
        easing: 'easeOutCubic',
      },
    },
  },
} as const satisfies ChartOptions<BarOrLineChart>;

export const zoomOptionsBarLineChart = {
  pan: {
    enabled: true,
    mode: 'x',
    scaleMode: 'x',
  },
  zoom: {
    drag: {
      enabled: false,
    },
    wheel: {
      enabled: false,
    },
    pinch: {
      enabled: false,
    },
    mode: 'x',
  },
} as const satisfies ZoomPluginOptions;
